<div class="container-fluid">
    <div class="gl-box-container">
        <div class="row p-1">
            <h6 class="grayFont"><b>Generate Letters</b></h6>
        </div>
        <p-divider></p-divider>
        <div class="row inner-box" >
            <div class="float-left">Cover letter / Support letter placeholders</div>
            <div class="float-right"><span (click)="handleRoutePath('elements')">Select related Elements/attributes <i class="fa fa-angle-right text-primary icon-style"></i></span></div>
        </div>
        <div class="row inner-box">
            <div class="float-left">Create Default Cover letter template</div>
            <div class="float-right"><span (click)="handleRoutePath('default-template','COVLTR')"><i class="fa fa-angle-right text-primary icon-style"></i></span></div>
        </div>
        <div class="row inner-box">
            <div class="float-left">Create Default Support letter template</div>
            <div class="float-right"><span (click)="handleRoutePath('default-template','SUPLTR')"><i class="fa fa-angle-right text-primary icon-style"></i></span></div>
        </div>
    </div>

    <div class="mt-4">
        <p-divider type="dashed" ></p-divider>
      </div>
      <div class="buttonContainer my-2">
        <div> <button type="button" class="btn vdCancelBtn mr-3" (click)="handleGoback()">GO BACK</button></div>
        <div> <button type="submit" class="btn vdCreateBtn mr-3" (click)="handleNext()">NEXT</button></div>
      </div>
    
</div>


